import factory from '../positions/asset-positions-factory';

import FxForwardsPosition from './fx-forwards-position';
import FxForwardsPositionDetails from './fx-forwards-position-details';

export default factory({
  assetCategory: 'fxForwards',

  RowComponent: FxForwardsPosition,
  ExpandedRowComponent: FxForwardsPositionDetails,
});
